import { render, staticRenderFns } from "./EditCar.vue?vue&type=template&id=6dad541a"
import script from "./EditCar.vue?vue&type=script&lang=js"
export * from "./EditCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports